/*
 * `uiFeatureAccessSymbol` is used to define page access-control properties across nested objects in `UIFeatures`.
 * This pattern is used to avoid name clashes and/or reserved property names.
 * Please, do not unintentionally replicate it. Use regular property names instead.
 */
export const uiFeatureAccessSymbol: unique symbol = Symbol('uiFeatureAccess');
